import { useCallback } from 'react';
import { useTranslation } from '@/i18n';
import type { FacilityFlowCoreModulesPlanningWorkflowsTimeClockTimeClockEventDto as TimeClockEvent } from '@/api/generated/models';
import { isHomeOffice, stretchLocations } from '@/utils/workLocation';

/**
 * Returns, for one day's events in chronological order, "Homeoffice" for every event of a home
 * office stretch — clock-in, breaks and clock-out alike — and null otherwise. Office is the
 * normal case and is not called out. One pass per day, so call it once per list, not per event.
 */
export function useDescribeWorkLocations(): (orderedDayEvents: TimeClockEvent[]) => (string | null)[] {
  const { t } = useTranslation('timeclock');

  return useCallback(
    (orderedDayEvents: TimeClockEvent[]) =>
      stretchLocations(orderedDayEvents).map((location) =>
        isHomeOffice(location) ? t('workLocation.homeOffice') : null,
      ),
    [t],
  );
}
